import { CancelTokenSource } from 'axios';
import { IApplicationComponentRef, IComponentRefCreate } from '../types';
import { ApiRepository } from './main repository/api.repository';

export const getComponentRefs = async (cancelTokenSource: CancelTokenSource): Promise<IApplicationComponentRef[]> => {
  return ApiRepository.Core().get(`${window.globalConfiguration.api.base}/v1/componentRefs`, undefined, {
    cancelToken: cancelTokenSource.token,
  });
};

export const createComponentRef = async (
  cancelTokenSource: CancelTokenSource,
  componentRef: IComponentRefCreate
): Promise<IApplicationComponentRef> => {
  return ApiRepository.Core().post(`${window.globalConfiguration.api.base}/v1/componentRefs`, componentRef, undefined, {
    cancelToken: cancelTokenSource.token,
  });
};

export const updateComponentRef = async (
  cancelTokenSource: CancelTokenSource,
  componentRef: Partial<IApplicationComponentRef>,
  id: number
): Promise<IApplicationComponentRef> => {
  return ApiRepository.Core().put(
    `${window.globalConfiguration.api.base}/v1/componentRefs/${id}`,
    componentRef,
    undefined,
    { cancelToken: cancelTokenSource.token }
  );
};
